module.exports = function() {
	return new Worker(__webpack_public_path__ + "90792a326a0b1f5cf518.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader!./src/lib/lex/wav-worker.js
// module id = 400
// module chunks = 1